import AppService from './AppService';

class ActivityService extends AppService {

  constructor() {
    super();
    this.path = this.getPath('activities');
  }

  create(data) {
    return this.http.post(`${this.path}`, data);
  }

  update(data, id) {
    return this.http.patch(`${this.path}/${id}`, data);
  }

  updateAll(data) {
    return this.http.patch(`${this.path}/all`, data);
  }

  read(id) {
    return this.http.get(`${this.path}/${id}`);
  }

  list(params = '') {
    const queryParams = params ? params : '';
    return this.http.get(`${this.path}${queryParams}`);
  }

  delete(id) {
    return this.http.delete(`${this.path}/${id}`);
  }

}

export default ActivityService;
